import React, { useState } from 'react';
import './styles/Home.scss';
import { FiSearch, FiPaperclip, FiArrowRight } from 'react-icons/fi';
import { BiBrain } from 'react-icons/bi';
import { BsCalendar, BsTools } from 'react-icons/bs';
import { RiMoneyDollarCircleLine } from 'react-icons/ri';
import { HiOutlineChartBar, HiOutlineCurrencyDollar } from 'react-icons/hi';
import { chatWithAI } from './services/openai';
import './App.css';
import AIResponse from './components/AIResponse';
import './styles/AIResponse.css';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

function App() {
  const [isPro, setIsPro] = useState(false);
  const [userInput, setUserInput] = useState('');
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(true);
  const [format, setFormat] = useState('paragraphs');

  const suggestions = [
    {
      icon: <BiBrain />,
      text: 'Analyze our blog post about Open Plan Kitchen Living and suggest 5 new campaign ideas. Display in a table format and include SEO keywords. Include a description of each idea.'
    },
    {
      icon: <BsTools />,
      text: '5 new blog ideas for our website'
    },
    {
      icon: <RiMoneyDollarCircleLine />,
      text: 'Write a newsletter using the content from the article Kitchen Curves'
    },
    {
      icon: <BsCalendar />,
      text: 'Using the content from our blog, suggest a social media campaign for the next month'
    }
  ];

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!userInput.trim()) return;

    console.log({
      userInput,
      format,
      timestamp: new Date().toISOString(),
    });

    setShowSuggestions(false);
    setIsLoading(true);

    const newUserMessage = { role: 'user', content: userInput };
    setMessages(prev => [...prev, newUserMessage]);

    try {
      const aiResponse = await chatWithAI(userInput, format);
      setMessages(prev => [...prev, {
        role: 'assistant',
        content: aiResponse
      }]);
    } catch (error) {
      console.error('Error:', error);
      setMessages(prev => [...prev, {
        role: 'system',
        content: 'Sorry, there was an error processing your request.'
      }]);
    } finally {
      setIsLoading(false);
      setUserInput('');
    }
  };

  const handleSuggestionClick = (suggestionText) => {
    setUserInput(suggestionText);
    // Create a small delay to ensure state is updated before submitting
    setTimeout(() => {
      const form = document.querySelector('.search-container form');
      if (form) {
        const submitEvent = new Event('submit', {
          bubbles: true,    // Let the event bubble up through the DOM
          cancelable: true  // Let the event be cancelable
        });
        form.dispatchEvent(submitEvent);
      }
    }, 0);
  };

  return (
    <div className="app-container">
      <div className="hero-banner">
        <div className="overlay"></div>
      </div>
      
      <div className="content-wrapper">
        <aside className="sidebar">
          <div className="logo-container">
            <img src="https://roundhousedesign.com/wp-content/uploads/2021/03/logo-footer.png" alt="Logo" />
          </div>
          
          <nav className="menu">
            <a href="#marketing" className="menu-item">
              <HiOutlineChartBar className="icon" />
              Marketing
            </a>
            <a href="#finance" className="menu-item">
              <HiOutlineCurrencyDollar className="icon" />
              Finance
            </a>
          </nav>
        </aside>

        <main className="main-content">
          <h1 className="title">Ask anything</h1>
          
          <div className="search-container">
            <div className="chat-container">
              {messages.map((message, index) => (
                <div key={index} className={`message ${message.role}`}>
                  {message.role === 'user' ? (
                    <div className="user-message">{message.content}</div>
                  ) : (
                    <AIResponse response={message.content} />
                  )}
                </div>
              ))}
              {isLoading && <div className="message system">Loading...</div>}
            </div>
            <form onSubmit={handleSearch}>
              <input
                type="text"
                className="search-input"
                placeholder="Ask anything..."
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                disabled={isLoading}
              />
              
              <div className="search-controls">
                <button 
                  type="button" 
                  className="control-button"
                  data-tooltip-id="common-tooltip"
                  data-tooltip-content="Coming soon"
                >
                  <FiSearch /> Focus
                </button>
                <button 
                  type="button" 
                  className="control-button"
                  data-tooltip-id="common-tooltip"
                  data-tooltip-content="Coming soon"
                >
                  <FiPaperclip /> Attach
                </button>

                <Tooltip id="common-tooltip" place="top" />

                <select 
                  className="format-select"
                  value={format}
                  onChange={(e) => setFormat(e.target.value)}
                >
                  <option value="">Response Type:</option>
                  <option value="table">Table</option>
                  <option value="list">List</option>
                  <option value="paragraphs">Paragraph</option>
                </select>

                
                
                <button type="submit" className="submit-button" disabled={isLoading}>
                  {isLoading ? 'Loading...' : 'CREATE'} <FiArrowRight />
                </button>
              </div>
            </form>
          </div>

          {showSuggestions && (
            <div className="suggestions">
              {suggestions.map((suggestion, index) => (
                <div 
                  key={index} 
                  className="suggestion-card"
                  onClick={() => handleSuggestionClick(suggestion.text)}
                  style={{ cursor: 'pointer' }}  // Optional: add pointer cursor
                >
                  <span className="suggestion-icon">{suggestion.icon}</span>
                  <span className="suggestion-text">{suggestion.text}</span>
                </div>
              ))}
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

export default App;

